export class VerifyOTPRequest {
    OTP: string;

    constructor(OTP: string) {
        this.OTP = OTP;
    }
}
